<!--
 * @Author: your name
 * @Date: 2021-08-16 14:23:41
 * @LastEditTime: 2022-05-12 10:58:09
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/add/index.vue
-->
<template>
  <div class="pay_success">
    <img src="/static/image/paysuccess.png" class="success_img" />
    <p class="success_text">付款成功</p>
    <p class="shopname">{{ shop || "店铺" }}</p>
    <p class="money">￥{{ money || 0 }}</p>
    <div class="lines"></div>
    <p class="pay_type">付款方式</p>
    <div class="pay_content">
      <div>会员卡</div>
      <div>￥{{ money || 0 }}</div>
    </div>
    <div class="lines"></div>
    <div class="success_btn" @click="handleComplete">完成</div>
  </div>
</template>
<script>
export default {
  name: "paysuccess",
  data() {
    return {
      money: 0,
      shop: ""
    };
  },
  mounted() {
    const { shop, money } = this.$route.query;
    this.shop = shop;
    this.money = money;
  },
  methods: {
    handleComplete() {
      wx.closeWindow();
    }
  }
};
</script>
<style scoped>
.pay_success {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  text-align: center;
  box-sizing: border-box;
  padding: 17px;
}
.success_img {
  width: 50px;
  height: 50px;
}
.success_text {
  width: 100%;
  font-size: 10px;
  margin-top: 6px;
  font-weight: 400;
  line-height: 17px;
  color: #757575;
}
.shopname {
  font-size: 13px;
  margin-top: 12px;
  font-weight: 500;
  line-height: 22px;
  color: #212121;
}
.money {
  font-size: 21px;
  margin-top: 6px;
  font-weight: 500;
  line-height: 35px;
  color: #ffa516;
}
.lines {
  width: 100%;
  height: 0;
  border-bottom: solid 1px #e0e0e0;
}
.pay_type {
  font-size: 10px;
  margin-top: 14px;
  width: 100%;
  text-align: left;
  font-weight: 400;
  line-height: 17px;
  color: #757575;
}
.pay_content {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 400;
  line-height: 19px;
  color: #002121;
  padding: 17px 0;
}
.success_btn {
  width: 100%;
  height: 29px;
  font-size: 13px;
  line-height: 29px;
  color: #212121;
  text-align: center;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  opacity: 1;
  border-radius: 3px;
  margin-top: 45px;
}
</style>



// WEBPACK FOOTER //
// src/paySuccess/index.vue